import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-footer-link',
  templateUrl: './footer-link.component.html',
  styleUrls: ['./footer-link.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class FooterLinkComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
